export const engagementAppGroupIdHasFeatureFlags = "/engagement/:app_group_id/has_feature_flags";
